import React from 'react';

export type NetworkLevel = 0 | 1 | 2 | 3 | 4;

interface NetworkStrengthBarsProps {
  level: NetworkLevel;
  size?: number;
}

const FILLED_COLOR: Record<number, string> = {
  0: '#d1d5db',
  1: '#ef4444',
  2: '#f59e0b',
  3: '#15a34a',
  4: '#15a34a',
};

const INACTIVE = '#d1d5db';

/**
 * Four-bar cellular-signal SVG that updates fill color based on `level` (0–4).
 * Level 0 = all gray, Level 1 = 1 red bar, Level 2 = 2 yellow bars,
 * Level 3–4 = 3–4 green bars.
 */
const NetworkStrengthBars: React.FC<NetworkStrengthBarsProps> = ({
  level,
  size = 20,
}) => {
  const filledColor = FILLED_COLOR[level] ?? FILLED_COLOR[4];

  const barColor = (barIndex: number): string =>
    barIndex <= level ? filledColor : INACTIVE;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Bar 1 — shortest (leftmost) */}
      <rect x="1" y="14" width="3" height="5" rx="1" fill={barColor(1)} />
      {/* Bar 2 */}
      <rect x="6" y="10" width="3" height="9" rx="1" fill={barColor(2)} />
      {/* Bar 3 */}
      <rect x="11" y="6" width="3" height="13" rx="1" fill={barColor(3)} />
      {/* Bar 4 — tallest (rightmost) */}
      <rect x="16" y="2" width="3" height="17" rx="1" fill={barColor(4)} />
    </svg>
  );
};

export default NetworkStrengthBars;
